import { graphql, useFragment } from 'react-relay';

import type { PaymentActiveITPValue_charge$key } from './__generated__/PaymentActiveITPValue_charge.graphql.ts';
import PaymentLinkActiveValue from '../paymentLinkActive/PaymentLinkActiveValue.tsx';

import type { ReactNode } from 'react';

type PaymentActiveITPValueProps = {
  charge: PaymentActiveITPValue_charge$key;
};

const PaymentActiveITPValue = (
  props: PaymentActiveITPValueProps,
): ReactNode => {
  const charge = useFragment<PaymentActiveITPValue_charge$key>(
    graphql`
      fragment PaymentActiveITPValue_charge on Charge {
        value
        valueWithDiscount
        company {
          ...PaymentLinkActiveValue_company
        }
      }
    `,
    props.charge,
  );

  return (
    <PaymentLinkActiveValue
      company={charge.company}
      value={charge.value}
      valueWithDiscount={charge.valueWithDiscount}
    />
  );
};

export default PaymentActiveITPValue;
